/** Core Services */
export const topDestinations = [
      {
    id: 'ai-automation',
    imageSrc: '/assets/img-17.jpeg',
    imageAlt: 'AI automation and smart business systems',
    label: 'AI Apps & Solutions',
    description:
      'Custom AI tools built by an experienced AI for business automation to automate tasks, improve customer interactions, and support business growth. From smart assistants to workflow tools, we create practical AI solutions for modern businesses.',
    href: '/services/ai-apps-solutions',
  },
  {
    id: 'website-development',
    imageSrc: '/assets/img-40.jpg',
    imageAlt: 'Website development and digital design workspace',
    label: 'Website Design & Development',
    description:
      'As a trusted web development company in Switzerland, we build high-performing websites designed for trust, conversions, and long-term growth. Our websites are modern, fast, SEO-ready, and built to turn visitors into customers.',
    href: '/services/website-design-development',
  },
    {
    id: 'digital-marketing',
    imageSrc: '/assets/img-38.jpg',
    imageAlt: 'Digital marketing analytics and growth strategy',
    label: 'Marketing & Tech Consulting',
    description:
      'Strategic consulting for businesses that need expert support with digital growth, automation planning, and system improvements. Our AI consulting services in Europe help businesses make better technology decisions with confidence.',
    href: '/services/marketing-tech-consulting',
  },
   {
    id: 'saas-startup-products',
    imageSrc: '/assets/img-42.jpg',
    imageAlt: 'SaaS and startup product development',
    label: 'SaaS & Startup Product',
    description:
      'As a modern SaaS development company, we help startups and growing businesses build scalable digital products, MVPs, and online platforms designed for market growth and long-term performance.',
    href: '/services/saas-startup-products',
  },

  {
    id: 'hotel-booking-systems',
    imageSrc: '/assets/img-37.jpeg',
    imageAlt: 'Hotel booking system and hospitality technology',
    label: 'Hotel Digital Solutions',
    description:
      'Specialized hotel digital solutions for hospitality businesses that want more direct bookings, stronger digital presence, and better guest experiences. We help hotels improve revenue and reduce reliance on third-party platforms.',
    href: '/services/hotel-digital-solutions',
  },
 


];

/** Business Growth Highlights */
export const experiences = [
  {
    id: 'GOOGLE ADS AGENCY',
    imageSrc:
      'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=1200&q=80',
    imageAlt: 'Business growth and revenue increase dashboard',
    label: 'GOOGLE ADS AGENCY',
    href: '/solutions/increase-revenue',
  },
  {
    id: 'reduce-commission-costs',
    imageSrc:
      'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&q=80',
    imageAlt: 'Reduce costs with direct booking and automation',
    label: 'Reduce Costs',
    href: '/solutions/reduce-costs',
  },
  {
    id: 'save-time-with-automation',
    imageSrc:
      'https://images.unsplash.com/photo-1526379095098-d400fd0bf935?auto=format&fit=crop&w=1200&q=80',
    imageAlt: 'Automation tools saving time for businesses',
    label: 'Save Time',
    href: '/solutions/save-time',
  },
  {
    id: 'grow-online',
    imageSrc:
      'https://images.unsplash.com/photo-1467232004584-a241de8bcf5d?auto=format&fit=crop&w=1200&q=80',
    imageAlt: 'Stronger online presence for modern businesses',
    label: 'Grow Online',
    href: '/solutions/grow-online',
  },
  {
    id: 'better-customer-experience',
    imageSrc:
      'https://images.unsplash.com/photo-1556740749-887f6717d7e4?auto=format&fit=crop&w=1200&q=80',
    imageAlt: 'Improved customer experience through digital solutions',
    label: 'Better Customer Experience',
    href: '/solutions/customer-experience',
  },
];